<template>
  <div class="result-card-download__card-info">
    <md-tooltip md-direction="bottom">
      Clique aqui para exportar
    </md-tooltip>
    <div class="result-card-download__card-info-count-available-results">
      <p>{{ totalResults }}</p>
    </div>
    <div class="result-card-download__card-info-text-content">
      <p>{{ title }}</p>
      <span>{{ text }}</span>
    </div>
    <div class="result-card-download__card-info-icon-content">
      <md-icon
        md-src="/static/images/icon-download-result.svg"
        class="icon-download"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCardDownload',
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    totalResults: {
      type: Number
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../static/stylesheets/variables";

.result-card-download {
  &__card-info {
    background-color: white;
    text-transform: uppercase;
    padding: 15px;
    border-radius: 5px;
    margin-left: 15px;
    display: flex;
    cursor: pointer;
    border: 2px solid white;

    &-count-available-results {
      background-color: rgba(127, 26, 84, 0.1);
      padding: 12px;
      border-radius: 5px;
      margin: auto;

      p {
        font-size: 19px;
        color: $brand-primary;
        font-weight: 500;
      }
    }

    &-text-content {
      padding: 5px;
      line-height: 16px;
      margin-top: auto;
      margin-left: 0.5em;
      flex: 1;

      p {
        font-size: 12px;
        font-weight: 500;
        color: #7a7a7a;
      }

      span {
        font-size: 11px;
        color: #b7b7b7;
        font-weight: 500;
      }
    }

    &-icon-content {
      width: 2em;
      margin: auto;

      .icon-download {
        fill: $brand-primary;
        width: 1.6em;
        height: 1.1em;
      }
    }

    &:hover {
      border: 2px solid $brand-primary;
      box-sizing: border-box;
      background-color: $brand-primary;
    }
    &:hover p,
    &:hover span {
      color: white;
      font-weight: 500;
    }

    &:hover .md-icon > svg .background {
      fill: white;
    }
    &:hover .md-icon > svg .arrow {
      stroke: $brand-primary;
      fill: white;
    }

    &:hover .md-icon > svg {
      animation: animateArrow 0.8s linear infinite;
    }
  }
}
</style>

